var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("Senior Life Insurance Company Ⓒ Copyright 2022")])])
}]

export { render, staticRenderFns }